import React, { Component } from "react";

import {
  Modal, TextContainer, TextField
} from "@shopify/polaris";

import { reqAddBrokenLinkById } from "../../api";


// import utils from '../../utils/utils';

import Language from '../../i18n/Language';
const t = Language

class AddRedirectActionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      AddRedirectActive:props.AddRedirectActive,
      domain:props.domain,
      AddPathValue:"",
      AddTargetValue:"",
      AddRedirectActiveLoading:false,
      opreState:0
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.AddRedirectActive !== this.state.AddRedirectActive) {
      let AddRedirectActive = nextProps.AddRedirectActive;
      this.setState({
        AddRedirectActive: AddRedirectActive,
      })
    }
    if(nextProps.domain !== this.props.domain){
      this.setState({
        domain:nextProps.domain
      })
    }
    return true
  }

  //关闭添加单个窗口
  handleChangeAddRedirect = () => {
    this.props.handleChangeAddRedirect()
  };

  handleChangeValue = (field, value) => {
    if(field === "AddPathValue"){
      value = "/"+ this.parseUrlValue(value);
      if (value) {
        value = "/" + value.replace("/", "");
      }
      if(value.lastIndexOf('https://') >= 0 || value.lastIndexOf('http://') >= 0 ){
        value = value.replace(/\/\//g, "/");
        value = value.replace(/http:\//g, "http://");
        value = value.replace(/https:\//g, "https://");
      }else{
        value = value.replace(/\/\//g, "/");
      }
    }else{
      var domainValue = this.domainValueJudge(value);
      if(domainValue === 0){
        // value = "/"+ this.parseUrlValue(value);
        if (value) {
          value = "/" + value.replace("/", "");
        }
        value = value.replace(/\/\//g, "/");
      }
    }
    this.setState({
      [field]: value
    });
  };

   //重新组织
   parseUrlValue = (value) =>{
    if(value.lastIndexOf('https://') === 0 || value.lastIndexOf('http://') === 0 ){
      var parseUrlRes = this.parseUrl(value);
      if(parseUrlRes.host !== null && parseUrlRes.protocol !== null){
        if(parseUrlRes.path !== null ){
          value = parseUrlRes.path
        }else{
          value = ""
        }
      }
    }
    return value
  }


   //判断是否有域名进行判断是否需要加斜杆  有域名返回1  没域名返回0
   domainValueJudge = (value) =>{
    var parseUrlRes = this.parseUrl(value);
    if(parseUrlRes.host !== null && parseUrlRes.protocol !== null){
      return 1
    }else{
      return 0
    }
  }

   //域名拆分
   parseUrl = (url) =>  {
    let urlObj = {
        protocol: /^(.+):\/\//,
        host: /:\/\/(.+?)[?#\s/]/,
        path: /\w(\/.*?)[?#\s]/,
        query: /\?(.+?)[#/\s]/,
        hash: /#(\w+)\s$/
    }
    url += ' '
    function formatQuery(str) {
        return str.split('&').reduce((a, b) => {
            let arr = b.split('=')
            a[arr[0]] = arr[1]
            return a
        }, {})
    }
    for(let key in urlObj) {
        let pattern = urlObj[key]
        urlObj[key] = key === 'query' ? (pattern.exec(url) && formatQuery(pattern.exec(url)[1])) : (pattern.exec(url) && pattern.exec(url)[1])
    }
    return urlObj
  }

  //提交单个
  handleChangeAddRedirectSave = async () => {
    if (this.state.AddPathValue === "") {
      this.props.toggleToast(t("Path cannot be empty"), true);
      return "";
    }

    if (this.state.AddTargetValue === "") {
      this.props.toggleToast(t("Target cannot be empty"), true);
      return "";
    }
    if (this.state.opreState === 1) {
      this.props.toggleToast(t("Please try again later"), true);
      return "";
    }
    this.setState({
      AddRedirectActiveLoading: true,
      opreState: 1
    });

    //调用修改接口
    const params = {
      frlink: this.state.AddPathValue,
      tolink: this.state.AddTargetValue
    };
    const response = await reqAddBrokenLinkById(params);

    if (response.code === 200) {
      //关闭请求状态
      this.setState({
        opreState: 0,
        AddRedirectActiveLoading: false,
        AddPathValue: "",
        AddTargetValue: ""
      },()=>{
       this.handleChangeAddRedirect()
        this.props.toggleToast(t(response.msg), false);
      });
    } else {
      //关闭请求状态
      this.setState({
        opreState: 0,
        AddRedirectActiveLoading: false
      },()=>{
        // this.getProductList()
        this.handleChangeAddRedirect()
        this.props.toggleToast(t(response.msg), true);
      });
    }

  };

  render() {
    return (
      <Modal
      open={this.state.AddRedirectActive}
      onClose={this.handleChangeAddRedirect}
      title={t("Create a Redirect")}
      primaryAction={[
        {
          content: t("Save"),
          onAction: this.handleChangeAddRedirectSave,
          loading: this.state.AddRedirectActiveLoading
        }
      ]}
      >
      <Modal.Section>
        <TextContainer>
          <TextField
            label={t("Path")}
            value={this.state.AddPathValue}
            onChange={this.handleChangeValue.bind(this, "AddPathValue")}
            prefix={this.state.domain}
            placeholder="e.g. /broken-link"
          />
          <TextField
            label={t("Target")}
            value={this.state.AddTargetValue}
            onChange={this.handleChangeValue.bind(this, "AddTargetValue")}
            placeholder='("/" = homepage url ) e.g. /collections'
          />
        </TextContainer>
      </Modal.Section>
    </Modal> 
    );
  }
}

export default AddRedirectActionModal;